export default __webpack_public_path__ + "static/media/PAFI_Announcement of GMS 2025.6a4a21fd.pdf";